<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">Configurações do parceiro</div>
                <div
                  class="client-name"
                  [title]="this.boobleModalData?.companyName || ''"
                >
                  Parceiro:
                  {{
                    this.boobleModalData?.companyName?.length > 55
                      ? (this.boobleModalData?.companyName | slice: 0 : 55) + '...'
                      : this.boobleModalData?.companyName
                  }}
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <form [formGroup]="configForm">
              <div>
                <p class="title-form mg-top-8">Configuração de spread</p>

                <div>
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Spread</mat-label>
                        <input
                          matInput
                          type="text"
                          class=""
                          formControlName="spread"
                          currencyMask
                          [options]="{
                            prefix: '',
                            thousands: '.',
                            decimal: ',',
                            suffix: ' %'
                          }"
                          required
                        />
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('spread')?.hasError('required')"
                        >
                          Spread obrigatório
                        </mat-error>
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('spread')?.hasError('min') || configForm.get('spread')?.hasError('max')"
                        >
                          Spread deve estar entre 0% e 100%
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                     <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Spread OZ</mat-label>
                        <input
                          matInput
                          type="text"
                          class=""
                          formControlName="institutionalSpread"
                          currencyMask
                          [options]="{
                            prefix: '',
                            thousands: '.',
                            decimal: ',',
                            suffix: ' %',
                            precision: 3
                          }"
                          required
                        />
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('institutionalSpread')?.hasError('required')"
                        >
                          Spread OZ obrigatório
                        </mat-error>
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('institutionalSpread')?.hasError('min') || configForm.get('institutionalSpread')?.hasError('max')"
                        >
                          Spread OZ deve estar entre 0% e 100%
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p class="title-form mg-top-8">Configuração de tarifa</p>

                <div>
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Tarifa</mat-label>
                        <input
                          matInput
                          type="text"
                          class=""
                          formControlName="tariff"
                          currencyMask
                          [options]="{
                            prefix: 'R$ ',
                            thousands: '.',
                            decimal: ','
                          }"
                          required
                        />
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('tariff')?.hasError('required')"
                        >
                          Tarifa obrigatória
                        </mat-error>
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('tariff')?.hasError('min')"
                        >
                          Tarifa não pode ser menor que zero
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
 
              <div>
                <p class="title-form mg-top-8">
                  Configuração de spread bancário
                </p>

                <div>
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Spread bancário</mat-label>
                        <mat-select
                          formControlName="spreadBanking"
                          required
                        >
                          <mat-option [value]="true">Ativado</mat-option>
                          <mat-option [value]="false">Desativado</mat-option>
                        </mat-select>
                        <mat-error
                          class="text-danger"
                          *ngIf="configForm.get('spreadBanking')?.hasError('required')"
                        >
                          Spread bancário obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal-footer-new">
          <button
            type="button"
            class="btn-footer btn btn-dark-primary-blue"
            type="button"
            [disabled]="configForm.invalid || loading"
            (click)="sendConfig()"
          >
            Salvar configurações
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
